export default class {
    constructor ($interval, $state, $translate, toastr, lodash, localStorageService, TokenService, PrivilegeService, jwtHelper) {
        this.$interval = $interval;
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.localStorageService = localStorageService;
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.jwtHelper = jwtHelper;
        this.key = 'coursy:auth:sites';
    }

    clear () {
        this.localStorageService.remove(this.key);
    }

    hasSites () {
        return !!this.sites;
    }

    get sites () {
        return this.localStorageService.get(this.key);
    }

    set sites (sites) {
        return this.localStorageService.set(this.key, sites);
    }

    getSitePrivileges (id) {
        const site = this.lodash.find(this.sites, ['id', id]);
        return site ? site.privileges : [];
    }

    hasAccessToAllSites (sites) {
        return this.PrivilegeService.isCompanyAdmin() || this.TokenService.getSiteCount() === sites.length;
    }

    getActiveSiteId () {
        return this.TokenService.getActiveSiteId();
    }

    getActiveSiteName () {
        const activeSite = this.lodash.find(this.sites, { id: this.getActiveSiteId() });
        return (activeSite) ? activeSite.name : '';
    }

    getSitesByPrivileges (privileges, ignoreCompanyAdmin = false) {
        if (this.PrivilegeService.isCompanyAdmin() && !ignoreCompanyAdmin) {
            return this.sites;
        }

        return this.lodash.filter(this.sites, site => {
            return this.lodash.some(site.privileges, privilege => this.lodash.includes(privileges, privilege));
        });
    }

    /**
     * Checks whether user has at least one given privilege in given site
     * @param int siteId
     * @param array privileges
     * @param boolean ignoreCompanyAdmin
     * @returns {boolean}
     */
    hasPrivilegeInSite (siteId, privileges, ignoreCompanyAdmin = false) {
        if (this.PrivilegeService.isCompanyAdmin() && !ignoreCompanyAdmin) {
            return true;
        }

        const sitePrivileges = this.getSitePrivileges(siteId);
        return sitePrivileges.filter(privilege => this.lodash.includes(privileges, privilege)).length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/site/index.js